const BASE_URL = '/api/tag/'

export const useTag = () => {
  const { fetchGet, fetchPost } = useCustomFetch()

  function getTag(id: string): Promise<Tag> {
    return fetchGet(BASE_URL + id)
  }

  function searchTag(q: SearchQuery): Promise<SearchResult<Tag>> {
    return fetchGet(BASE_URL + 'search' + toSearchQueryString(q))
  }

  function createTag(tag: Tag): Promise<Tag> {
    return fetchPost(BASE_URL + 'create', tag)
  }

  const coreTagCacheKey = 'jps-tag-service-core-tag'

  async function getCoreTags(): Promise<Tag[]> {
    let tags = ssGet<Tag[]>(coreTagCacheKey)
    if (!tags) {
      tags = (await searchTag({ filter: { type: ['CORE'] } })).list
      await ssSet(coreTagCacheKey, tags)
    }
    return tags
  }

  return {
    getTag,
    searchTag,
    createTag,
    getCoreTags,
  }

}
